import { ArtistType, OrganizationUnitType } from '@api';
import {
  Anchor,
  getValueByPath,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { GeneralInformationTableRowType } from '../../types';

type GeneralInformationTableRowPropsType = {
  artist: ArtistType;
  row: GeneralInformationTableRowType;
  organizationUnits: OrganizationUnitType[];
};

export const GeneralInformationTableRow: React.FC<
  GeneralInformationTableRowPropsType
> = ({ artist, row, organizationUnits }) => {
  const { t } = useTranslation('artistDetailsGeneral');

  const getRenderValue = () => {
    const value = getValueByPath(artist, row.accessor);
    const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    if (value === null) return noDataPlaceholder;

    switch (row.accessor) {
      case 'website':
        return (
          <Anchor to={artist.website!} target="_blank">
            {artist.website}
          </Anchor>
        );
      case 'artistLink':
        return (
          <Anchor to={artist.artistLink!} target="_blank">
            {artist.artistLink}
          </Anchor>
        );
      case 'genre':
        return artist.genre.length > 0
          ? artist.genre
              .map((g) => t(`GENRES.${g}`, { ns: 'artists' }))
              .join(', ')
          : noDataPlaceholder;
      case 'isDomesticArtist':
        return artist.isDomesticArtist ? t('YES') : t('NO');
      case 'isFemaleAct':
        return artist.isFemaleAct ? t('YES') : t('NO');
      case 'defaultOrganizationUnit':
        return (
          organizationUnits.find(
            (organizationUnit) =>
              organizationUnit.id === artist.defaultOrganizationUnit
          )?.name ?? noDataPlaceholder
        );
      default:
        return String(value);
    }
  };

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>
        {t(`GENERAL_INFORMATION.ROWS.${row.label}`)}
      </TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
